import React from 'react';
import Banner from '../../../components/Banner/index';
import Footer from '../../../components/Footer/index';

class FAQPage extends React.Component {
  render() {
    return (
      <div>
        <Banner />
        <div className="sub-banner">
          <div className="overlay">
            <div className="container">
              <div className="breadcrumb-area">
                <div className="top">
                  <h1>Preguntas Frecuentes</h1>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="typography-page">
          <div className="container">
            <div className="row mrg-btm-40">
              <div className="col-md-12">
                <h3>1. ¿Qué es Escena Digital?</h3>
                <p>Escena es una plataforma digital con alcance global que conecta teatros con producciones de ópera y de ballet ya estrenadas y con artistas.</p>

                <h3>2. ¿Quién puede registrarse en Escena Digital?</h3>

                <p>Escena ofrece 3 opciones de registro</p>

                <ul>
                  <li>A: PRODUCTOR: Teatros productores, compañías y festivales líricos o aquellas entidades que producen de forma regular ópera y/o ballet</li>

                  <li>B: TEATROS / VENUES: Programadores, teatros o salas que no necesariamente producen ópera y/o ballet pero tienen el espacio para recibir producciones de este tipo y buscan producciones clásicas de calidad.</li>

                  <li>C: ARTISTA: Cantantes líricos que hayan cantado en los teatros de la red OLA en los últimos 2 años.</li>
                </ul>
                <h3>3. ¿Qué ofrece Escena Digital?</h3>

                <p>A través de perfiles, Escena ofrece visibilidad para sus 3 tipos de usuarios, mostrando la oferta disponible de teatros, espacios, producciones disponibles para comercializar, así como también un catálogo de artistas (cantantes líricos) Latinoamericanos.</p>

                <p>A productores y teatros ofrecemos:</p>

                <ul>
                  <li>Información sobre el equipo artístico, presupuestos, videos, clippings de prensa entre otros</li>

                  <li>Documentos relacionados con las producciones como inventarios y más</li>

                  <li>Contacto directo para comercializar producciones o espacios. </li>

                  <li>Kit de herramientas con información relevante a la hora de comercializar producciones como por ejemplo: políticas aduaneras en LATAM, contratos tipos y más</li>

                  <li>Boletín informativo con las últimas novedades de Escena </li>

                  <li>Dar “me gusta” a producciones, artistas y agregar a lista de favoritos.</li>

                  <li>Estadísticas / Analytics del perfil, entregando información sobre quién visita la pagina, producción, desde donde, etc.</li>
                </ul>

                <p>ARTISTAS podrán presentar su trabajo de una forma visualmente atractiva y completa</p>

                <ul>
                  <li>Podrán subir notas de prensa, videos, archivos de audio y fotografías para promocionar su trabajo y carrera.</li>

                  <li>Estadísticas / Analytics de sus páginas: Podrán ver la cantidad de visitas a su perfil y el origen entre otros datos. </li>

                  <li>Mediante mailings mensuales Recibirán información sobre concursos, audiciones y clases magistrales </li>

                  <li>Podrán acceder a información relacionada al desarrollo de sus carreras</li>
                </ul>

                <h3>4. ¿Cuánto cuesta registrarse en Escena Digital?</h3>

                <p>Escena ofrece 3 opciones: </p>

                <p><strong>Perfil gratuito:</strong> con esta alternativa puedes crear un perfil como PRODUCTOR o VENUE, mostrar tu teatro o compañía y subir hasta 1 (una) producción. Tienes una visualización parcial de archivos y de los datos de contacto de otros teatros.</p>

                <p><strong>Plan standard por $500USD anuales:</strong> Pensado para PRODUCTORES y VENUES, este plan te permite subir 10 fotografías, hasta 10 producciones o un perfil de teatro o venue completo; te da acceso a visualización total de la información compartida por los otros teatros, documentos de toolkit, contactar directamente a teatros y compañías y ser contactado. </p>

                <p><strong>Plan Premium por $800USD anuales:</strong> esta opción reúne todos los beneficios del plan para PRODUCTORES y para VENUES. La opción Premium es ideal para teatros productores que tienen producciones para ofrecer y que además quieren promocionar sus salas.</p>

                <p><strong>Artistas:</strong> Una vez habilitada, esta sección tendrá un precio standard anual de $100 USD. Los usuarios podrán crear su perfil de cantantes con registro, roles que hayan interpretados. Además podrán subir: su CV, fotos, videos, soundclouds, redes sociales, biografía y documentos como cartas de recomendación, clippings de prensa, etc.</p>

                <p>Puedes revisar el detalle de lo que cada tipo de paquete ofrece <a href="http://escena.digital/plans">aquí</a></p>

                <h3>5. ¿Cómo puedo registrarme a Escena Digital?</h3>

                <p>Tanto PRODUCTORES como TEATROS (venues) se puedes registrar a Escena completando esta <a href="http://escena.digital/theaterRegister">ficha de registro</a>. No olvides completar todos los campos y adjuntar archivos en formato PDF y fotografías en alta definición con dimensiones de 900X600.</p>

                <p>Para ser parte de Escena Artistas contáctanos en hello@escena.digital</p>

                <h3>6. ¿Se verifica cada perfil que se registra en la plataforma?</h3>

                <p>Si, para mantener la calidad de la página tenemos como política revisar el contenido de todo lo que se sube a la plataforma. </p>

                <h3>7. ¿Cómo funciona?</h3>

                <p>Escena está pensando como un catálogo que te muestra la oferta disponible de producciones, espacios y artistas, conectando a las partes interesadas. La transacción final se hace directamente entre las partes. <strong>No en la plataforma.</strong></p>

                <p>Como usuario PRODUCTOR, TEATRO o PREMIUM podrás vitrinear producciones, teatros y artistas. Podrás dar “me gusta” o guardar en tu lista de favoritos producciones que te interesen y contactar directamente a la persona que maneja el teatro, sala o producción que quieras arrendar o comprar. </p>

                <p>También podrás acceder a la sección de Estadísticas o Analytics que te dirá quién ha visitado tu página, desde dónde proviene la visita y más.</p>

                <h3>8. ¿Puedo modificar mis datos después de su publicación?</h3>

                <p>Si, al acceder a tu perfil -con tu nombre de usuario y contraseña puedes modificar los datos de tu perfil y de la(s) producciones que subiste. Esto aplica tanto a PRODUCCIONES, TEATROS y ARTISTAS</p>

                <h3>9. Soy programador, Administrador de un teatro, espacio o sala. ¿Qué tipo de usuario debo seleccionar?</h3>

                <p>Debes seleccionar la opción TEATRO o VENUE, donde podrás mostrar el espacio o teatro que administras y vitrinear producciones disponibles para programar en tu venue.</p>

                <h3>10. ¿Qué puedo publicar como TEATRO, VENUE o programador?</h3>

                <p>Como TEATRO, VENUE o programador, puedes publicar fotos del espacio que administras, la historia o biografía de dicho lugar, fichas técnica para que quienes busquen espacios para llevar sus producciones sepan las dimensiones, con qué equipo técnico cuentas y capacidad de tus salas o espacios.</p>

                <h3>11. ¿Qué puedo encontrar como VENUE o programador?</h3>

                <p>Al registrarte como TEATRO, VENUE o programador, además de mostrar y ofrecer los espacios disponibles de tu teatro o espacio, podrás buscar producciones para tu temporada o programación. Con esta opción de registro podrás acceder a información como: Producciones disponibles para arriendo o venta, detalles técnicos de las producciones, clippings de prensa, videos y podrás contactar al teatro o compañía dueña de la producción directamente para adquirir la obra que te interesa</p>

                <h3>12. Soy un teatro productor, Festival lírico, Compañía lírica ¿Qué tipo de usuario debo seleccionar?</h3>

                <p>Debes seleccionar la opción PRODUCTOR, con la que podrás crear el perfil de tu teatro, compañía o festival y subir hasta 10 producciones para comercializar. Para más información de los beneficios de este plan haz <a href="http://escena.digital/plans">click aquí</a></p>

                <p>Si eres un teatro o espacio que además de producir ópera y ballet te interesa ofrecer las salas, foyers de tu venue para arriendo, te recomendamos suscribirte en el plan PREMIUM que incluye ambas opciones. Subir producciones y un perfil más completo para tu espacio.</p>

                <h3>13. ¿Qué puedo publicar como PRODUCTOR?</h3>

                <p>Como productor puedes subir producciones de ópera y ballet que tengas disponible para venta o arriendo. Fichas que llevan fotos, documentos específicos como inventario, clippings de prensa y videos. Además de mostrar y promocionar tu teatro, compañía o festival. </p>

                <h3>14. ¿Qué diferencia hay con la opción PREMIUM?</h3>

                <p>La diferencia es la cantidad de producciones que puedes subir, sólo 10 como productor y hasta 20 con la alternativa Premium. Además como Premium puedes subir más fotos de tu espacio entre otros beneficios</p>

                <h3>15. ¿Qué beneficios tengo como PRODUCTOR?</h3>

                <p>Como productor puedes generar un ingreso extra al tener más posibilidades de comercializar tus producciones</p>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default FAQPage;



// WEBPACK FOOTER //
// ./src/containers/General/FAQPage/index.js